import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { useEffect, useState } from 'react';

import { Helmet } from 'react-helmet';

import { News, useNews } from 'api/news';
import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { NewsCard } from 'widgets/cards';
import { useLanguage } from '../../context/LanguageContext';
import { newsPageLabels }  from '../../locales/translations';

export const NewsPage = () => {
    const [newsList, setNewsList] = useState<News[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const { onGetAllNews } = useNews();

    const { language } = useLanguage();
    const title = newsPageLabels.title[language];
    const pageTitle = newsPageLabels.pageTitle[language];
    const metaDescription = newsPageLabels.metaDescription[language];

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllNews();
                if (result.success) {
                    const filteredAndSortedNews = result.data
                        .filter((newsItem: News) => newsItem.show) // Отображаем только новости с show === true
                        .sort((a: News, b: News) => 
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setNewsList(filteredAndSortedNews);
                    console.log(newsList);
                    
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    // eslint-disable-next-line
    }, [onGetAllNews]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {newsList.map((newsItem) => (
                            <GridChild md={3} key={newsItem.id}>
                                <NewsCard newsItem={newsItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
